import { useQuery } from "@apollo/client/react";
import GET_REJECTION_EMAIL_TEMPLATES from "../../queries/contentful/getRejectionEmailTemplates";
import { contentfulClient } from "../../contentfulClient";

interface Response {
  rejectionEmailTemplatesCollection?: {
    items?: Array<{
      id: string;
      title: string;
      content: string;
    }>;
  };
}

export const useRejectionEmailTemplates = () => {
  const { data, error, loading, refetch } = useQuery<Response>(
    GET_REJECTION_EMAIL_TEMPLATES,
    {
      client: contentfulClient,
    }
  );
  return {
    rejectionTemplates: data?.rejectionEmailTemplatesCollection,
    error,
    loading,
    refetch,
  };
};
